import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ChangedPasswordVerifier() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/logowanie');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
      <div style={{ padding: '40px', borderRadius: '12px', border: '1px solid #e2e8f0', textAlign: 'center' }}>
        <div style={{ fontSize: '2.5rem' }}>✅</div>
        <h2>Hasło zostało zmienione!</h2>
        <p style={{ color: '#64748b' }}>Możesz się teraz zalogować przy użyciu nowego hasła.</p>
        <p style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Za chwilę nastąpi przekierowanie do logowania...</p>
      </div>
    </div>
  );
}